// src/routes/SoloAdminRoute.jsx
// Envuelve una ruta que solo puede abrir un admin.
//
// Hace falta porque el control de la app es la mitad del tema: ocultar el link
// del navbar NO alcanza, cualquiera que escriba la URL a mano entra igual (por eso
// el TablerosAdminPage decía "solo role=admin" en el comentario y en realidad no
// lo estaba: /tableros-v2 era accesible para contable, seguimiento y user).
//
// El gating de verdad igual está en el backend (soloAdmin, esAdminOJavier), esto
// es solo para que no se llegue a la pantalla.
//
// Ojo: AppRouter ya esperó a que authReady esté en true antes de montar esto, así
// que role no llega acá en null por estar cargando la sesión.
import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../context/authContext';

export const SoloAdminRoute = ({ children }) => {
    const { role } = useContext(AuthContext);

    if (role !== 'admin') {
        return <Navigate to="/inicio" replace />;
    }

    return children;
};